module.exports = __webpack_public_path__ + "static/assets/de8cfe29e4802278e2e42e66fbb79d7b.svg";